import React from "react";
import {Modal} from "./Modal";

const LiveDarshanModal = ({isModalOpen, closeModal, liveStreamData}) => {
    return (
        <Modal isOpen={isModalOpen} onClose={closeModal}>
            <div className="flex flex-col w-[80vw] h-[90vh] sm:h-[90vh] max-h-[90vh] bg-white rounded-lg">
                {/* Header */}
                <div
                    className="h-[7vh] min-h-[7vh] max-h-[7vh]
                    px-[2.5vh] flex flex-col justify-between"
                >
                    <div className={"flex-1 flex flex-row items-center justify-between gap-x-[4vh]"}>
                        {/* Form Title */}
                        <h2 className="sm:text-[2.25vh] text-[1.75vh] font-custom-semi-bold">
                            {liveStreamData.title}
                        </h2>

                        <button
                            onClick={closeModal}
                            type="button"
                            className="flex items-center justify-center
                            rounded-md w-[2.5vh] h-[2.5vh] aspect-square bg-[#D4D4D4]
                            hover:bg-[#F7F7F7] hover:ring hover:ring-[#D4D4D4]
                            transition duration-200 ease-out
                            text-sm text-gray-400 hover:text-gray-900"
                        >
                            <img
                                className={"w-[75%] aspect-square"}
                                src={"assets/close-icon.png"}
                                alt={"Close Icon"}
                            />
                        </button>
                    </div>

                    {/* Divider */}
                    <div className={"h-[0.2vh] w-full bg-[#ECECEC] rounded-full"}/>
                </div>

                {/* LiveStream YouTube Video */}
                <div
                    className="h-[83vh] min-h-[83vh] max-h-[83vh]
                    flex-1 flex items-center justify-center
                    p-[2.5vh] pt-[1.5vh] rounded-md"
                >
                    {liveStreamData.videoId ? (
                        // YouTube Live Video
                        <iframe
                            width="100%"
                            height="100%"
                            src={`https://www.youtube.com/embed/${liveStreamData.videoId}?autoplay=1`}
                            title="YouTube video"
                            frameBorder="0"
                            className="rounded-md"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    ) : (
                        // Streaming Soon Banner
                        <div className={"rounded-md relative h-full w-full flex items-center justify-center"}>
                            <div className="rounded-md absolute inset-0 z-10">
                                <div className="rounded-md h-full w-full bg-black/25 backdrop-blur-xl"/>
                                <img
                                    src={liveStreamData.streamingSoonMaskUrl}
                                    alt={"Live Stream Starting Soon"}
                                    className={"rounded-md -z-10 absolute inset-0 h-full w-full object-cover"}
                                />
                            </div>
                            <img
                                src={liveStreamData.streamingSoonMaskUrl}
                                alt={"Live Stream Starting Soon"}
                                className={"h-full object-contain z-10"}
                            />
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default LiveDarshanModal;
